import Vue from 'vue'
import Quasar from 'quasar-framework'
import store from '../store'
import VueI18n from 'vue-i18n'
import helpers from '../helpers/methods'
import moment from 'moment'

const {capitalize} = helpers

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    messages: {}
})

i18n.T = function (str) {
    return capitalize(this.t(str))
}

Vue.use({
    install() {
        Vue.prototype.$T = function (str) {
            return capitalize(this.$t(str))
        }
        Vue.prototype.$_t = function (str, tokens) {
            return strTokenReplace(this.$t(str), tokens)
        }
        Vue.prototype.$_T = function (str, tokens) {
            return capitalize(this.$_t(str, tokens))
        }
    }
})

/**
 * @param {String} locale
 */
export async function loadMessages(locale) {
    if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
        const messages = await import(/* webpackChunkName: "lang-[request]" */ `../../../lang/${locale}.json`)
        i18n.setLocaleMessage(locale, messages)
    }

    let qlocale = locale
    if (qlocale == 'en') qlocale = 'en-uk'
    if (Quasar.i18n.lang != qlocale) {
        const lang = await import(`../../../../node_modules/quasar-framework/i18n/${qlocale}`)
        Quasar.i18n.set(lang.default)
    }

    let mlocale = locale
    if (mlocale == 'en') mlocale = 'en-gb'
    if (moment.locale != mlocale) {
        const lang = await import(`../../../../node_modules/moment/locale/${mlocale}.js`)
        moment.locale(mlocale)
    }

    if (i18n.locale !== locale) {
        i18n.locale = locale
    }
}

(async function () {
    await loadMessages(store.getters['lang/locale'])
})()

export default i18n


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/i18n.js